module.exports = __webpack_public_path__ + "img/skrill.244208b8.svg";